import styled, { css } from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import InputSimple, { phoneDecorator } from '@r1-frontend/ui-react/components/inputSimple';
import Throbber from '@r1-frontend/ui-react/components/loaders/Throbber';
import { NamePhoneForm } from '@r1-frontend/ui-react/organisms/Forms/NamePhoneForm';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

const templates = {
    first: `
        grid-template-columns: min-content 218px;
        grid-template-rows: min-content min-content;
        grid-template-areas:
            "input input"
            "button checkbox";
        grid-gap: 0 8px;
    `,
    second: css`
        grid-template-columns: 232px 187px;
        grid-template-rows: min-content min-content;
        grid-template-areas:
            "input button"
            "checkbox checkbox";
        grid-gap: 0 8px;
    `,
    mobile: css`
        grid-template-columns: 1fr;
        grid-template-rows: min-content min-content 16px min-content;
        grid-template-areas:
            "input"
            "checkbox"
            "margin"
            "button";
        grid-gap: 0;
    `,
};

export type TTemplate = keyof typeof templates;

export const StyledThrobber = styled(Throbber)`
    position: absolute;
`;

export const SNamePhoneForm = styled(NamePhoneForm)``;

export const GridTemplate = styled.div<{variant: TTemplate}>`
    display: grid;
    ${p => templates[p.variant]};
    align-items: flex-start;
`;

export const RequestFormWrapper = styled.div<{isMobile?: boolean}>`
    position: relative;
    display: flex;
    flex-direction: column;
`;

export const Input = styled(InputSimple)`
    grid-area: input;

    [data-test="placeholder"] {
        display: none;
    }

    [class*="InputError"] {
        white-space: nowrap;
    }
`;

export const Phone = phoneDecorator(Input);

export const Title = styled.div<{isMobile?: boolean}>`
    margin-bottom: ${p => p.isMobile ? '12px' : '24px'};
    ${p => p.isMobile ? FONTS.H5 : FONTS.H4};
`;

export const Button = styled(BaseButton)<{isMobile?: boolean}>`
    grid-area: button;
`;
